import config from 'config'
import {BRANDS, LOGIN_CASES} from 'const'
import {getDefaultConfig, getFooterLogosByBrandList} from '../commonHelper'
import {isProd} from 'utils/envUtils'
import {FOOTER_LOGO_TYPES} from 'const/logos'

const NORMAL_FONT = "'Ringier-Light', Times New Roman, sans-serif"
const BOLD_FONT = "'Ringier-Bold', Times New Roman, sans-serif"

const authorizeRedirectURL = `https://${!isProd() ? 'staging.' : ''}moonandstars.ch/api/auth/login`

export default {
  brand: {
    name: BRANDS.moonandstars,
    url: 'https://moonandstars.ch/',
    support: 'https://moonandstars.ch/de/contact',
    favicon: `${config.url}/assets/mas-favicon.png`,
    fontColor: '#FFFFFF',
    authorizeRedirectURL,
  },
  config: {
    ...getDefaultConfig(),
    marketingOnePager: ({loginCase}) => loginCase === LOGIN_CASES.EMAIL_ONLY,
    newsletterOnePager: true,
    marketingConsent: true,
    onePager: ({loginCase}) => LOGIN_CASES.EMAIL_ONLY === loginCase,
    newsletterConsent: true,
    useCircularSocialLogin: true,
  },
  fontConfig: {custom: {urls: [`${config.url}/fonts/ringier/index.css`]}},
  font: {
    family: NORMAL_FONT,
    boldFamily: BOLD_FONT,
    size: '14px',
    height: '20px',
    mobile: {size: '16px', height: '24px'},
    portrait: {size: '16px', height: '24px'},
    color: {dark: '#000000', light: '#FFFFFF'},
    fontWeight: '400',
    boldFontWeight: '700',
  },
  secondaryFont: {
    size: '14px',
    height: '20px',
    mobile: {size: '14px', height: '20px'},
    portrait: {size: '16px', height: '24px'},
  },
  title: {
    family: BOLD_FONT,
    size: '28px',
    height: '32px',
    mobile: {size: '28px', height: '32px'},
    portrait: {size: '44px', height: '48px'},
    weight: 'bold',
  },
  ringierBanner: {
    benefitsIcon: `${config.url}/assets/NRJ-icon-check.svg`,
    linkColor: '#777777',
    linkHoverColor: '#000000',
    linkFontSize: '14px',
    padding: '20px',
    benefitMessageColor: '#777777',
    backgroundColor: '#F9F9F9',
    titleFontWeight: 700,
    titleFontFamily: BOLD_FONT,
    fontSize: '14px',
    lineHeight: '20px',
    iconWidth: '24px',
    iconHeight: '24px',
    landscape: {
      fontSize: '16px',
    },
    onelogTitle: {
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '20px',
      color: '#000000',
      fontFamily: BOLD_FONT,
      margin: '0 0 20px 0',
    },
    onelogSection: {
      padding: '40px 0 0 0',
      borderTop: '1px solid #B8C2CB',
    },
  },
  otherBrandsLogos: getFooterLogosByBrandList([BRANDS.moonandstars, BRANDS.energy, BRANDS.blick, BRANDS.twentymin]),
  note: {
    family: BOLD_FONT,
    fontSize: '18px',
    fontWeight: '700',
    lightFontWeight: '400',
    termsTitle: {
      fontWeight: 'bold',
      fontFamily: BOLD_FONT,
    },
  },
  notification: {
    family: '',
    success: '#009067',
    error: '#E30613',
    pageError: '#E30613',
    warning: '#FFB120',
    info: '#9F95C0',
    icon: {
      width: '24px',
      height: '24px',
      mobile: {width: '32px', height: '32px'},
    },
    pageMessage: {size: '16px', height: '24px'},
  },
  buttons: {
    height: '50px',
    primary: {
      border: '2px',
      color: '#FFFFFF',
      background: '#3E438B',
      hoverBackground: '#252A74',
      activeBorder: 'none',
      focusBorder: '2px solid #9f95c0',
      activeBackground: '#252A74',
      isAnimated: true,
    },
    secondary: {
      border: '1px solid #3E438B',
      color: '#252A74',
      background: '#FFFFFF',
      hoverBorder: '1px solid #252A74',
      hoverColor: '#FFFFFF',
      hoverBackground: '#252A74',
      focusBorder: '2px solid #252A74',
      focusColor: '#252A74',
      focusBackground: '#FFFFFF',
      activeBorder: '2px solid #252A74',
      activeColor: '#FFFFFF',
      activeBackground: '#252A74',
      dotsColor: '#252A74',
    },
    disabled: {
      border: '#C1C1C1',
      color: '#FFFFFF',
      background: '#C1C1C1',
      hoverBorder: null,
      hoverBackground: '#C1C1C1',
      activeBorder: null,
      activeBackground: '#C1C1C1',
    },
    swiss: {
      activeColor: '#000',
      background: '#fff',
      border: '1px solid currentColor',
      color: '#777',
      focusBorder: '2px solid currentColor',
      focusColor: '#000',
      hoverColor: '#000',
      icon: 'swiss_id_rot.png',
      iconStyles: {padding: '12px', marginLeft: '0'},
      isAnimated: false,
    },
    apple: {
      activeColor: '#000',
      background: '#fff',
      border: '1px solid currentColor',
      color: '#777',
      focusBorder: '2px solid currentColor',
      focusColor: '#000',
      full: true,
      hoverColor: '#000',
      icon: 'logo-apple-black.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
    },
    facebook: {
      activeColor: '#000',
      background: '#fff',
      border: '1px solid currentColor',
      color: '#777',
      focusBorder: '2px solid currentColor',
      focusColor: '#000',
      hoverColor: '#000',
      icon: 'icon-facebook-24x24.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      isAnimated: false,
    },
    google: {
      activeColor: '#000',
      background: '#fff',
      border: '1px solid currentColor',
      color: '#777',
      focusBorder: '2px solid currentColor',
      focusColor: '#000',
      hoverColor: '#000',
      icon: 'icon-google-24x24.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      isAnimated: false,
    },
    touchId: {
      border: '2px',
      color: '#FFFFFF',
      background: '#3E438B',
      hoverBackground: '#252A74',
      activeBorder: 'none',
      focusBorder: '2px solid #9f95c0',
      activeBackground: '#252A74',
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      isAnimated: false,
    },
    faceId: {
      border: '2px',
      color: '#FFFFFF',
      background: '#3E438B',
      hoverBackground: '#252A74',
      activeBorder: 'none',
      focusBorder: '2px solid #9f95c0',
      activeBackground: '#252A74',
      icon: 'icon-faceid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      isAnimated: false,
    },
    anyId: {
      border: '2px',
      color: '#FFFFFF',
      background: '#3E438B',
      hoverBackground: '#252A74',
      activeBorder: 'none',
      focusBorder: '2px solid #9f95c0',
      activeBackground: '#252A74',
      isAnimated: false,
    },
    icon: {height: '24px', width: '24px'},
    text: {
      family: BOLD_FONT,
      color: '#000000',
      size: '16px',
      weight: '700',
    },
    border: {size: '1px', radius: '0'},
    linkOnSecondLine: true,
  },
  link: {
    default: '#854896',
    hoverColor: '#252A74',
    secondary: '#777777',
    secondaryHover: '#000000',
    isAgreementsLinkSecondary: true,
  },
  logisterSection: {
    registerFamily: BOLD_FONT,
    registerMarginTop: '20px',
    registerWeight: 700,
    subheaderBorderTop: '1px solid #d9d9d9',
    subheaderPadding: '16px 20px',
    subheaderFontSize: '14px',
    subheaderFamily: BOLD_FONT,
    subheaderLineHeight: '20px',
    subheaderTitleColor: '#000000',
    subheaderLinkColor: '#777777',
    subheaderLinkHoverColor: '#000000',
    subheaderBackgroundColor: '#EFEFEF',
    noteColor: '#777777',
    noteFontSize: {
      default: '12px',
      portrait: '14px',
    },
    title: {
      textChangeBreakpoint: 'mobile',
      fontSize: {
        smallMobile: '23px',
        mobile: '28px',
        portrait: '28px',
        landscape: '38px',
        desktop: '38px',
      },
      lineHeight: {
        smallMobile: '28px',
        mobile: '32px',
        portrait: '32px',
        landscape: '44px',
        desktop: '44px',
      },
    },
    subtitle: {
      color: '#000000',
      fontSize: {
        default: '14px',
        portrait: '14px',
      },
      lineHeight: '20px',
      margin: '0',
      link: {
        color: '#000000',
        hoverColor: '#000000',
      },
    },
  },
  form: {
    border: '',
    background: '#F9F9F9',
    fieldBackground: '',
    padding: '0 0 12px 0',
    sectionViewBackground: '#f8f8f8',
    marginBottom: '8px',
    loginSubmitMarginTop: '0',
  },
  logisterForm: {border: '', background: '', padding: '', submitButton: 'primary', forgetLinkFloat: 'right'},
  loginForm: {
    forgetLink: {
      wrapper: {
        defaultMarginBottom: '20px',
        errorMarginBottom: '22px',
      },
      link: {
        fontSize: '14px',
        marginTop: '8px',
      },
    },
  },
  registerPage: {
    backLinkMargin: {default: '0 0 12px', portrait: '0 0 20px'},
    titleMargin: {default: '0 0 12px', portrait: '0 0 20px'},
    submitButtonMarginTop: 0,
  },
  emailVerifyPage: {
    smallNoteMarginTop: '8px',
    linkMarginBottom: '12px',
    pageMessageMarginBottom: '44px',
    note: {
      fontFamily: BOLD_FONT,
    },
  },
  field: {
    margin: '-20px -20px 20px -20px',
    mobileMargin: '-20px -20px 20px -20px',
    error: {
      background: 'inherit',
      fontColor: '#E30613',
      size: '14px',
      height: '20px',
      padding: '4px 20px 0',
      margin: '0 -20px',
    },
    label: {
      color: '#000000',
      disabledColor: 'rgba(31,31,31,0.6)',
      family: BOLD_FONT,
      fontSize: '16px',
      fontHeight: '24px',
      bottomMargin: '4px',
      fontWeight: 'bold',
    },
    optional: {
      family: NORMAL_FONT,
      weight: '300',
    },
    edging: {
      backgroundColor: '#F9F9F9',
    },
  },
  input: {
    border: '1px solid #777777',
    focusBorder: '1px solid #000',
    hoverBorder: '1px solid #777777',
    height: '50px',
    padding: '8px 12px',
    email: {
      backgroundColor: '#F2F2F2',
      border: '0',
      button: {
        height: '32px',
        right: '12px',
        backgroundColor: '#FFFFFF',
        color: '#3E438B',
        fontSize: '14px',
        textDecoration: 'none',
        border: '1px solid #3E438B',
        borderRight: '1px solid #3E438B',
        hoverColor: '#FFFFFF',
        hoverBackgroundColor: '#3E438B',
        hoverBorder: '1px solid #3E438B',
        hoverBorderRight: '1px solid #3E438B',
      },
      placeholder: {
        color: '#C1C1C1',
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
    password: {color: '#777777', hoverColor: '#000000', size: '14px', height: '20px', top: '14px'},
    loading: {top: '7px'},
    background: '#fff',
    errorBackground: '#FFE8E8',
    errorBorder: '1px solid #E30613',
  },
  checkbox: {
    icon: {
      height: '16px',
      width: '16px',
      top: '3px',
      right: '12px',
      image: 'BEO-form-checkbox.svg',
      checkedImage: 'BEO-form-checkbox-checked.svg',
      hoverImage: 'BEO-form-checkbox-hover.svg',
      errorImage: 'BEO-form-checkbox-error.svg',
      disabledImage: 'BEO-form-checkbox-inactive.svg',
    },
    errorMargin: '',
    padding: '20px',
    labelFontHeight: '24px',
    group: {
      label: {
        marginBottom: '4px',
        padding: '0',
        backgroundColor: '',
      },
      marginBottom: '20px',
      padding: '0 20px',
      backgroundColor: '#F9F9F9',
      fontWeight: '400',
      fontSize: '16px',
      note: {fontWeight: '300', fontSize: '14px', marginLeft: '28px', color: '#777777', lineHeight: '22px'},
    },
    errorPadding: '4px 20px 0',
  },
  select: {
    icon: {
      width: '16px',
      height: '16px',
      image: 'NRJ-icon-arrow-down-grey.svg',
      focusImage: 'NRJ-from-arrow-down-hover.svg',
      alt_image: 'NRJ-icon-arrow-down-grey.svg',
    },
    menu: {
      border: '1px solid #BBBBBB',
      checkIcon: 'NRJ-check-form-grey.svg',
      option: {
        focusBorder: '0',
        focusBackground: '#FFFFFF',
        focusColor: '#682F7C',
      },
    },
  },
  radio: {
    icon: {
      width: '16px',
      height: '16px',
      image: 'BEO-form-radio.svg',
      checkedImage: 'BEO-form-radio-active.svg',
      hoverImage: 'BEO-form-radio-hover.svg',
      errorImage: 'BEO-form-radio-error.svg',
      disabledImage: 'BEO-form-radio-empty-inactive.svg',
    },
    errorMargin: '0 -20px 0px',
    labelFontHeight: '24px',
    labelMarginBottom: '8px',
  },
  errorPage: {font: {height: '18px', portrait: {height: '30px'}}},
  inputNote: {
    family: NORMAL_FONT,
    weight: '300',
    color: '#1F1F1F',
    size: '14px',
    height: '20px',
    marginTop: '4px',
  },
  separator: {
    transform: 'capitalize',
    background: '#B8C2CB',
    color: '#8A939A',
    height: '1px',
    fontSize: '14px',
    lineHeight: '16px',
    portraitMargin: '24px 0 28px 0',
  },
  tab: {
    fontSize: '18px',
    desktop: {focusBorder: 'solid 4px #000000', bottomMargin: '-4px', height: '80px'},
    mobile: {icon: {border: 'solid 2px #ACACAC', width: '14px', height: '14px', color: '#000000'}},
  },
  shell: {
    header: {
      height: {
        default: '80px',
        onScroll: '56px',
        withEmail: '102px',
      },
      color: '#FFF',
      backgroundColor: '#000',
      border: {
        width: '0',
      },
      poweredLogo: {
        src: 'logo-onelog-poweredby-white.png',
      },
      logo: {
        height: {
          default: '24px',
          small: '17px',
          onScroll: '17px',
        },
        src: {
          default: 'logo-mas.svg',
        },
      },
      languageSwitcher: {
        color: '#FFFFFF',
        activeColor: '#000',
        backgroundColor: '#FFFFFF',
        menu: {
          fontSize: '14px',
          lineHeight: '22px',
          color: '#000',
          hoverBackgroundColor: '#cdd5db',
        },
      },
      menu: {
        default: {
          color: '#FFFFFF',
          fontSize: '20px',
        },
        active: {
          color: '#FFFFFF',
          backgroundColor: '#000',
          hoverBackgroundColor: '#3E438B',
          selectedBackgroundColor: '#252A74',
          separatorColor: '#2C3B47',
        },
      },
    },
    footer: {
      tenants: {
        logoColor: FOOTER_LOGO_TYPES.black,
        color: '#777',
        hoverColor: '#000',
        backgroundColor: '#F9F9F9',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: '#cdd5db',
      },
      copyright: {
        color: '#efefef',
        hoverColor: '#FFF',
        backgroundColor: '#000',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: '#cdd5db',
      },
    },
  },
  consent: {checkbox: {marginBottom: '20px', paddingBottom: ''}},
  mobileNumber: {
    label: {
      marginBottom: '16px',
    },
    subtitle: {
      marginTop: '4px',
    },
    select: {
      padding: '12px 0px 12px 12px',
    },
    selectIcon: {
      padding: '0px 12px',
    },
    code: {
      letterSpacing: '8px',
      paddingLeft: {
        normal: 'calc(50% - 58px)',
        error: 'calc(50% - 59px)',
      },
      underline: {
        left: 'calc(50% - 28px)',
        top: 'calc(50% - 7px)',
      },
    },
    questionLabel: {
      family: BOLD_FONT,
      weight: '300',
    },
    link: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  address: {
    padding: '20px 20px 0px 20px',
    inputBackgroundColor: '',
    formFieldMarginBottom: '',
    checkboxPadding: '0px 0px 20px 0px',
    link: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  social: {
    title: {
      fontSize: '16px',
    },
  },
}
